export default __webpack_public_path__ + "static/Litepaper - Portuguese-27d3ba6be54648fd102cc05b8b476e50.pdf";